import React, { useMemo } from 'react';
import { DateTime } from 'luxon';
import { AudioPlayer } from '@ems/client-design-system';

export const AudioPlayback = ({ audio, isPlaying, currentTime, playbackSpeed }: any) => {
  const audioArray = useMemo(() => [audio], [audio]);
  if (audio && audio.resourceUri && audio.resourceUri.uri) {
    const convertedStartTime = DateTime.fromISO(audio.startTime).toSeconds();
    const convertedEndTime = DateTime.fromISO(audio.endTime).toSeconds();

    return (
      <AudioPlayer
        noiseEvents={audioArray}
        startTime={convertedStartTime}
        endTime={convertedEndTime}
        isPlaying={isPlaying}
        position={currentTime}
        playbackSpeed={playbackSpeed}
      />
    );
  }

  return null;
};
